import React, {createRef, useMemo, useState} from "react";
import Question from "../../pretest/question";
import Headerback from "../../../component/headerback";


// 【唯一改题位置】后续换题只改这里，label里自己写好A/B/C/D前缀
const defalutschema = {
  id: 7, // 每次换题数字+1，彻底杜绝缓存
  desc: '概念篇',
  totalScore: 0,
  question: [
    {
      id: 1,
      desc: '"酒"在古典诗词中常承载复杂情感。以下诗句中，哪一项的"酒"所传达的情感基调与其他三项最为不同?',
      the_score: 0,
      options: [
        {
          label: '醉卧沙场君莫笑，古来征战几人回？',
          value: '醉卧沙场君莫笑，古来征战几人回？',
          score: 0,
          selected: false
        },
        {
          label: '浊酒一杯家万里，燕然未勒归无计。',
          value: '浊酒一杯家万里，燕然未勒归无计。',
          score: 0,
          selected: false
        },
        {
          label: '红酥手，黄滕酒，满城春色宫墙柳。',
          value: '红酥手，黄滕酒，满城春色宫墙柳。',
          score: 1, // 正确答案C，选中得分
          selected: false
        },
        {
          label: '艰难苦恨繁霜鬓，潦倒新停浊酒杯。',
          value: '艰难苦恨繁霜鬓，潦倒新停浊酒杯。',
          score: 0,
          selected: false
        }
      ],
      selected: []
    }
  ]
}

// 【彻底禁用缓存】强制用最新题目，完全不读本地旧数据
const a_schema = defalutschema;
let refs = [];

export default function Partone() {
    const [schema, setSchema] = useState(a_schema);
    let { question, desc } = schema;
    const [finish, setFinish] = useState(false);
    const [finishScore, setFinishScore] = useState(0);
    const [btnDisabled, setBtnDisabled] = useState(false);

    let totalScore;
    let newSchema = {
        id: defalutschema.id,
        totalScore: 0,
        question: [],
    };

    const handleSave = () => {
        setBtnDisabled(true);
        setFinish(true);
        totalScore = 0;

        schema.question.forEach((item, index) => {
            const { getSchema } = refs[index].current;
            const currentQuestionSchema = getSchema();
            newSchema.question.push(currentQuestionSchema);
            if (currentQuestionSchema.the_score) {
                totalScore += currentQuestionSchema.the_score;
            }
        });

        newSchema.totalScore = totalScore;
        window.localStorage.schema = JSON.stringify(newSchema);
        setFinishScore(newSchema.totalScore);
        
        // 提交解析文案
        alert(`你本次答对${newSchema.totalScore}道题!\n1、解析：A项（王翰《凉州词》）写边塞将士置生死于度外的豪迈与悲凉；B项（范仲淹《渔家傲》）写戍边将士思乡与功业未成的愁苦；D项（杜甫《登高》）写晚年贫病交加、国难家愁的沉郁。这三项均以“酒”表现家国情怀或人生困顿的“悲慨”。C项（陆游《钗头凤》）中“黄滕酒”是追忆往昔美满爱情的意象，酒中承载的是个人情感的悔恨与眷恋，情感基调为“哀婉”，与其他三项的“悲慨”截然不同。`)
    }

    useMemo(() => {
        refs = question.map(item => createRef());
    }, [question])

    return(
        <div className="partone-force-fix">
            {/* 【核心修复：最强CSS，100%抹除子组件自带的所有前缀】 */}
            <style>{`
                /* 强制隐藏子组件生成的所有前缀，覆盖所有可能的渲染结构 */
                .partone-force-fix .question label > span:first-child,
                .partone-force-fix .question .option-prefix,
                .partone-force-fix .question .option > span:first-child,
                .partone-force-fix .question .radio-item > span:first-child,
                .partone-force-fix .question .choice-item span:first-child {
                    display: none !important;
                    width: 0 !important;
                    height: 0 !important;
                    overflow: hidden !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }
            `}</style>

            <Headerback
                showPage={1}
            />
            <div className="page course-page">
                 <div className="page-con">
                     <div className="partonefour">
                         <div className="problem-inner">
                             <p className="desc">{desc}</p>
                             {
                                 schema.question.map((item, index) => {
                                  return (
                                    <div key={item.id} className="question">
                                      <p className="title">{item.id}、{item.desc}</p>
                                      {/* yanz严格对应4个选项，正确答案是第3个，所以第3位是2 */}
                                      <Question finish={finish} item={item} ref={refs[index]} yanz={[1,1,2,1]}></Question>
                                    </div>)
                                })
                             }
                         </div>
                     </div>
                     <button
                        className="miaov-btn miaov-btn-md problem-btn"
                        type="button"
                        onClick={handleSave}
                        disabled={btnDisabled}
                        style={{
                            backgroundColor: btnDisabled ? 'gray' : '',
                            cursor: btnDisabled ? 'default' : 'pointer',
                            display: btnDisabled ? 'none' : 'inline-block'  
                        }}
                    >
                        提交
                    </button>
                 </div>
            </div>
        </div>
    )
}